import { AxiosError, AxiosResponse } from "axios";

import store from "@/store";

import { RequestConfig } from "@/interfaces/http/request-config";

import { ResponseInterceptor } from "@/types/http/response-interceptor";

/**
 * Propagates information that request with given id has finalized
 * @param requestId Request unique id
 */
const propagateRequestItemNotPendingState = (requestId: string) => {
  store.dispatch("ui/popRequestStackItem", requestId);
};

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * UI HTTP response interceptor.
 * It helps to determine whether any request is still pending,
 * so we can display appropriate information for user.
 */
export const uiResponseInterceptor: ResponseInterceptor = {
  onFulfilled(value: AxiosResponse): Promise<AxiosResponse> | AxiosResponse {
    propagateRequestItemNotPendingState(
      (value.config as RequestConfig).requestId as string
    );
    return value;
  },
  onRejected(error: AxiosError): any {
    propagateRequestItemNotPendingState(
      (error.config as RequestConfig).requestId as string
    );
    return Promise.reject(error);
  }
};
